import { expVal } from '@confluence/feature-experiments';

import type { ContentRefetchHandlerProps } from './ContentRefetchHandler.ts';

type UpdateShouldRefetchContent = (state: { shouldRefetchContent: boolean }) => void;

const shouldNotRefetchContentState = { shouldRefetchContent: false };

export const getContentRefetchHandlerProps = ({
	contentId,
	shouldRefetch,
	updateShouldRefetchContent,
	updateShouldRefetchContentContext,
}: {
	contentId?: string;
	shouldRefetch: boolean;
	updateShouldRefetchContent: UpdateShouldRefetchContent;
	updateShouldRefetchContentContext?: unknown;
}): ContentRefetchHandlerProps => {
	const contentRefetchHandlerProps = {
		contentId,
		shouldRefetch,
	};

	if (expVal('task_cache_invalidation_fix', 'isEnabled', false)) {
		return {
			...contentRefetchHandlerProps,
			refetchImmediately: true,
			onRefetchComplete: () =>
				updateShouldRefetchContent.call(
					updateShouldRefetchContentContext,
					shouldNotRefetchContentState,
				),
		};
	}

	return contentRefetchHandlerProps;
};
